<template>
  <template v-for="(value, index) in values" :key="value">
    <div class="row">
      <a-form-item label="Identificador">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :value="value"
          @update:value="(newValue: number) => handleChange(newValue, index)"
          placeholder="Seleccionar tipo de bot"
          :disabled="disabled"
        >
          
          <a-select-option
            v-for="channelCustomer in channelCustomers"
            :disabled="
              values.includes(channelCustomer.id) || channelCustomer.is_associated_with_ivr_queue || channelCustomer.is_associated_queue ||
              !!blockedIdentifiers?.[channelCustomer.id]
            "
            :key="channelCustomer.id"
          >
            <a-tooltip placement="right">
              <template #title v-if="channelCustomer.is_associated_with_ivr_queue || channelCustomer.is_associated_queue || blockedIdentifiers?.[channelCustomer.id]">
                <span v-if="blockedIdentifiers?.[channelCustomer.id]">Este identificador ya está vinculado al Agente IA «{{ blockedIdentifiers[channelCustomer.id] }}».</span>
                <span v-else-if="channelCustomer.is_associated_queue">Este identificador ya está vinculado a una cola.</span>
                <span v-else-if="channelCustomer.is_associated_with_ivr_queue">Este identificador ya está vinculado a un IVR operador automático.</span>
              </template>
              <icon-channel 
                :type="channelCustomer?.channel_id" 
                :src="channelCustomer?.channel_icon" 
                :width="20" 
              />
              <span class="alias-tag"> - {{ displayAlias(channelCustomer) }} </span>
            </a-tooltip>
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-button type="link" :disabled="disabled" danger class="button" @click="handleDelete(index)">
        <DeleteOutlined />
      </a-button>
    </div>
  </template>

  <div class="action">
    <a-button type="link" class="button" :disabled="disabled" @click="handleAdd">
      <PlusOutlined />
      Agregar identificador
    </a-button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons-vue";
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";
import { ChannelCustomer } from "@/@types/global";
import { fetchAllChannelsCustomers } from "@/app/channels/services";
import { ChannelType } from "@/app/shared/utils/enums";

const props = defineProps<{
  channelType: (typeof ChannelType)[keyof typeof ChannelType];
  values: Array<number | undefined>;
  disabled?: boolean;
  /** Mapa id de identificador -> nombre del Agente IA que ya lo usa */
  blockedIdentifiers?: Record<number, string>;
}>();

const emit = defineEmits<{
  (e: "update:values", values: Array<number | undefined>): void;
}>();

const channelCustomers = ref<ChannelCustomer[]>([]);

onMounted(async () => {
  const channel_whatsapp_voice = await fetchAllChannelsCustomers(10);
  const channel_inbound_call = await fetchAllChannelsCustomers(props.channelType);
  channelCustomers.value = [...channel_whatsapp_voice, ...channel_inbound_call]
});

const displayAlias = (channelCustomer: ChannelCustomer) => {
  const alias = channelCustomer.data_parameters?.alias;
  return alias ? `alias: ${alias}` : "sin alias";
};

const handleDelete = (index: number) => {
  const currentValues = [...props.values];
  currentValues.splice(index, 1);

  emit("update:values", currentValues);
};

const handleAdd = () => {
  const currentValues = [...props.values];
  currentValues.push(undefined);

  emit("update:values", currentValues);
};

const handleChange = (newValue: number, index: number) => {
  const currentValues = [...props.values];
  currentValues[index] = newValue;

  emit("update:values", currentValues);
};
</script>

<style scoped lang="sass">
.button
  padding: 0

.ant-form-item
  margin: 0
  flex: 1 1 auto

.row
  display: flex
  align-items: flex-end
  gap: 12px
  margin-bottom: 16px

.action
  width: 100%
  border-top: 1px solid $gray-4
  text-align: center

.alias-tag
  color: $gray-7
  font-style: italic
  font-size: $font-small

:deep(.ant-select-item-option-disabled img)
  filter: grayscale(100%) opacity(.35) 
</style>
